/* global WooVariationDuplicator, _, jQuery */
'use strict';
jQuery( function ( $ ) {
	// Variation Image Clone
	class VariationImageClone {
		static init() {
			// this.setOption()
			this.events();

			$( '#woocommerce-product-data' ).on(
				'woocommerce_variations_loaded',
				() => {
					this.setCloneWrapper();
					this.setSelect2();

					// this.setOption()
					// this.events()
				}
			);

			$( '#variable_product_options' ).on(
				'woocommerce_variations_added',
				() => {
					this.setCloneWrapper();
					//this.setOption()
					this.events();
					this.setSelect2();
				}
			);
		}

		static setCloneWrapper() {
			$( '.woocommerce_variation' ).each( function () {
				const optionsWrapper = $( this ).find( '.options:first' );
				const chooseVariationsIdWrapper = $( this ).find(
					'.woo-variable-image-duplicator-wrapper'
				);
				chooseVariationsIdWrapper.insertBefore( optionsWrapper );
			} );
		}

		static setSelect2() {
			try {
				$( ':input.variable-image-duplicate-select' )
					.filter( ':not(.enhanced)' )
					.each( ( index, element ) => {
						const select2Args = {
							minimumResultsForSearch: 10,
							allowClear: !! $( element ).data( 'allow_clear' ),
							placeholder: $( element ).data( 'placeholder' ),
							templateResult: this.imgCloneFormFormat,
							templateSelection: ( state ) =>
								state.text || state.id,
						};

						$( element )
							.select2( select2Args )
							.addClass( 'enhanced' );

						/**
						 * Update the appearance with image when selection changes
						 *
						 * This function resolve the issue of image not showing on select2 appearance after selection,
						 * it's showing [object object]
						 * @see https://github.com/woocommerce/selectWoo/issues/31
						 */
						$( element ).on( 'select2:select', function ( e ) {
							const thumbnailUrl = $(
								e.params.data.element
							).data( 'thumbnail_url' );

							if ( thumbnailUrl ) {
								const $container =
									$( this ).next( '.select2-container' );
								const $rendered = $container.find(
									'.select2-selection__rendered'
								);

								$container.addClass(
									'select2-container--has-thumbnail'
								);
								$rendered.css(
									'--thumbnail-url',
									'url(' + thumbnailUrl + ')'
								);
							}
						} );
					} );
			} catch ( err ) {
				window.console.log( 'Select2 Error: ', err );
			}
		}

		static imgCloneFormFormat( state ) {
			if ( ! state.id ) {
				return state.text;
			}

			const thumbnailUrl = $( state.element ).data( 'thumbnail_url' );

			if ( thumbnailUrl ) {
				return $(
					'<img class="variation-duplicator-thumbnail-image-preview" src="' +
						thumbnailUrl +
						'" alt=" ' +
						state.text +
						'" width="30" height="30"/> <span class="variation-duplicator-thumbnail-image-text">' +
						state.text +
						'</span>'
				);
			}

			return state.text;
		}

		static setOption() {
			const $select = $( '#field_to_edit' );
			const actionsWrapper = $select.find( 'option:first' );
			$select
				.find( 'option.woo_variation_duplicate_option' )
				.insertAfter( actionsWrapper );
		}

		static events() {
			$( '#variable_product_options' )
				.on(
					'click',
					':input.variable-image-duplicate-type',
					this.chooseType
				)
				.on( 'click', 'button.select_all_variations', this.selectAll )
				.on( 'click', 'button.select_no_variations', this.selectNone )
				.on( 'change', ':input.upload_image_id', this.clearChooseType );
		}

		static clearChooseType() {
			$( this )
				.closest( '.woocommerce_variable_attributes' )
				.find(
					'.woo-variable-image-duplicator-wrapper .variable_image_duplicate_type_form_field :radio'
				)
				.prop( 'checked', false );
			$( this )
				.closest( '.woocommerce_variable_attributes' )
				.find( '.woo-variable-image-duplicator-wrapper .variable-list' )
				.removeClass( 'show' );
		}

		static chooseType() {
			const type = $( this ).val();

			$( this )
				.closest( '.woo-variable-image-duplicator-wrapper' )
				.find( '.variable-list' )
				.removeClass( 'show' );

			if ( type === 'to' ) {
				const uploadImageID = parseInt(
					$( this )
						.closest( '.woocommerce_variation' )
						.find( ':input.upload_image_id' )
						.val(),
					10
				);
				if ( isNaN( uploadImageID ) || uploadImageID < 1 ) {
					$( this )
						.closest( '.woo-variable-image-duplicator-wrapper' )
						.find( '.variable-image-duplicate-to-notice' )
						.addClass( 'show' );
					return;
				}
			}

			$( this )
				.closest( '.woo-variable-image-duplicator-wrapper' )
				.find( '.variable-image-duplicate-' + type )
				.addClass( 'show' );
		}

		static selectAll( event ) {
			event.preventDefault();

			$( this )
				.closest( 'p' )
				.find( 'select > option' )
				.prop( 'selected', true );
			$( this ).closest( 'p' ).find( 'select' ).trigger( 'change' );
		}

		static selectNone( event ) {
			event.preventDefault();

			$( this )
				.closest( 'p' )
				.find( 'select > option' )
				.prop( 'selected', false );
			$( this ).closest( 'p' ).find( 'select' ).trigger( 'change' );
		}
	}

	// Variation Product Clone
	class VariationProductClone {
		static init() {
			this.setHowTo();

			$( document ).on(
				'click',
				'input.variation_is_cloneable',
				this.cloneableClick
			);
			$( document ).on(
				'change',
				'input.variation_is_cloneable',
				this.cloneableChange
			);
			$( 'select.variation_actions' ).on(
				'woo_variation_duplicate_ajax_data',
				this.ajaxData
			);
			$( document ).on(
				'woocommerce_variations_added',
				'#variable_product_options',
				this.clean
			);
			$( document ).on(
				'woocommerce_variations_removed',
				'#woocommerce-product-data',
				this.clean
			);
			$( document ).on(
				'click',
				'#variation-duplicator-for-woocommerce-action-button',
				this.duplicate
			);

			const events = $._data( document.body, 'events' ).change;
			const inputChangeCallback = events.filter( ( event ) => {
				return (
					event.selector ===
					'#variable_product_options .woocommerce_variations :input'
				);
			} )[ 0 ];

			let isVariationLinked = false;
			$( document ).ajaxSuccess( function ( event, jqXHR, ajaxOptions ) {
				const params = new URLSearchParams( `?${ ajaxOptions.data }` );
				const ajaxData = Object.fromEntries( params );

				if ( ajaxData?.action === 'woocommerce_link_all_variations' ) {
					isVariationLinked = true;
				}

				if (
					isVariationLinked &&
					ajaxData?.action === 'woocommerce_load_variations'
				) {
					isVariationLinked = true;

					_.delay( () => {
						isVariationLinked = false;

						$( '#variable_product_options' ).trigger(
							'woocommerce_variations_linked'
						);
					}, 1000 );
				}
			} );

			// @TODO: We should add namespace support on event also
			$( document.body ).off(
				'change input',
				'#variable_product_options .woocommerce_variations :input'
			);
			$( document.body ).on(
				'change input',
				'#variable_product_options .woocommerce_variations :input:not(.no-track-change)',
				inputChangeCallback.handler
			);

			// Re Init

			$( '.wc-metaboxes-wrapper' ).on(
				'click',
				'button.add_variation_manually',
				function () {
					$(
						'.variation-duplicator-for-woocommerce-notice'
					).remove();
				}
			);

			$( '#woocommerce-product-data' ).on(
				'woocommerce_variations_loaded',
				() => {
					this.setHowTo();

					$(
						'#variation-duplicator-for-woocommerce-action-button'
					).prop( 'disabled', true );

					// Add variation added visual highlight effect
					const $notice = $(
						'.variation-duplicator-for-woocommerce-notice'
					);
					const duplicatedIds = $notice?.data( 'duplicated-ids' );
					if ( duplicatedIds ) {
						let $newVariations = $();

						$.each( duplicatedIds, function ( index, id ) {
							const $variation = $(
								'.variation_is_cloneable[value="' + id + '"]'
							).closest( '.woocommerce_variation' );

							if ( $variation.length ) {
								$newVariations =
									$newVariations.add( $variation );
							}
						} );

						if ( $newVariations.length ) {
							$newVariations.addClass( 'duplicated' );

							setTimeout( () => {
								$newVariations
									.addClass( 'fade-highlight' )
									.removeClass( 'duplicated' );

								setTimeout( () => {
									$newVariations.removeClass(
										'fade-highlight'
									);
								}, 300 );
							}, 500 );
						}
					}
				}
			);

			// No longer exists on wc 7.8 ( Update: But again available on 8.0.0 )
			$( '#variable_product_options' )
				.on( 'woocommerce_variations_added', () => {
					this.setHowTo();
					//$('select.variation_actions').off('woo_variation_duplicate_ajax_data').on('woo_variation_duplicate_ajax_data', this.ajaxData)
				} )
				.on( 'woocommerce_variations_input_changed', function () {
					// We wait for attaching out event for no change track
					_.delay( () => {
						$( this )
							.find(
								'.variation-needs-update input.variation_is_cloneable'
							)
							.prop( 'checked', false );
					}, 1 );
				} )
				.on( 'woocommerce_variations_linked', function () {
					$( this )
						.find( '.woocommerce_variation' )
						.addClass( 'variation-needs-update' );
					$( this )
						.find( '.woocommerce_variations.wc-metaboxes' )
						.prepend(
							'<div class="inline notice variation-duplicator-for-woocommerce-notice error"><p>' +
								WooVariationDuplicator.saveNoticeText +
								'</p></div>'
						);
				} );
		}

		static duplicate() {
			$( 'select#field_to_edit' )
				.val( 'woo_variation_duplicate' )
				.trigger( 'change' );
		}

		static setHowTo() {
			const button = $( '#variable_product_options_inner' ).find(
				'#variation-duplicator-for-woocommerce-action-button'
			);
			const actionsWrapper = $(
				'#variable_product_options_inner .toolbar-top'
			).find( '.do_variation_action' );
			const selectBox = $( 'select#field_to_edit' );
			//$('#variable_product_options_inner').find('.variation-duplicator-for-woocommerce-works').insertAfter(actionsWrapper)

			if ( actionsWrapper.length > 0 ) {
				button.insertAfter( actionsWrapper );
			} else {
				button.insertAfter( selectBox );
			}
		}

		static clean() {
			$(
				'.woocommerce-notice-invalid-variation, .woo-variation-duplicator-notice'
			).remove();
		}

		static ajaxData( data ) {
			const clone = { items: [], times: 1, exceed: false };
			const $clonable = $( 'input.variation_is_cloneable:checked' );
			const checked = $clonable.length;

			if ( checked < 1 ) {
				// eslint-disable-next-line no-alert
				window.alert( WooVariationDuplicator.noCheckedText );

				return ( data.clone = {} );
			}

			$clonable.each( function () {
				clone.items.push( $( this ).val() );
			} );

			if ( clone.items.length > 0 ) {
				const times = Number(
					// eslint-disable-next-line no-alert
					window.prompt( WooVariationDuplicator.limitText, '1' )
				);

				if ( isNaN( times ) ) {
					return ( data.clone = {} );
				}
				clone.times =
					times > Number( WooVariationDuplicator.limit ) ? 1 : times;
				clone.exceed = times > Number( WooVariationDuplicator.limit );
			} else {
				return ( data.clone = {} );
			}

			const total = clone.times * clone.items.length;
			const variationsWrapper = $( '#variable_product_options' ).find(
				'.woocommerce_variations'
			);
			for ( let $i = 0; $i < total; $i++ ) {
				// $('#variable_product_options').trigger('woocommerce_variations_added', 1)

				const totalVariation =
					parseInt( variationsWrapper.attr( 'data-total' ), 10 ) + 1;
				variationsWrapper.attr( 'data-total', totalVariation );
			}

			return ( data.clone = clone );
		}

		static cloneableClick() {
			if ( $( this ).is( ':checked' ) ) {
				$( this )
					.closest( 'label.clone-checkbox' )
					.addClass( 'checked' );
				$( '#variation-duplicator-for-woocommerce-action-button' ).prop(
					'disabled',
					false
				);
			} else {
				if ( $( 'input.variation_is_cloneable:checked' ).length < 1 ) {
					$(
						'#variation-duplicator-for-woocommerce-action-button'
					).prop( 'disabled', true );
				}

				$( this )
					.closest( 'label.clone-checkbox' )
					.removeClass( 'checked' );
			}
		}

		static cloneableChange() {
			$( this )
				.closest( '.wc-metaboxes-wrapper' )
				.find( '.wc-metabox > .wc-metabox-content' )
				.hide();
			$( this )
				.closest( '.woocommerce_variations' )
				.find( '.woocommerce_variation.open' )
				.removeClass( 'open' )
				.addClass( 'closed' );
		}
	}

	VariationImageClone.init();
	VariationProductClone.init();
} );
